import React from 'react';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { NEW_HEADER_FLAG } from 'constants/feature-flags';
import { RouteName } from 'components/dynamic-page/route-matchers';
import dynamic from 'next/dynamic';

// Dynamic imports to avoid loading both headers unless needed
const LegacyHeader = dynamic(() => import('./legacy-header'), {
  loading: () => <></>,
  ssr: true,
});

const NewHeader = dynamic(() => import('./new-header'), {
  loading: () => <></>,
  ssr: true,
});

type ZooHeaderProps = {
  routeName?: RouteName;
};

export type PanelItem = {
  id: string;
  label: string;
  link?: string;
  isEmber?: boolean;
  nested?: PanelItem[];
};

const ZooHeader = ({ routeName }: ZooHeaderProps) => {
  const growthbook = useGrowthBook();
  
  // Check if the new header feature flag is enabled (default to false for legacy)
  const isNewHeaderEnabled = growthbook.getFeatureValue(NEW_HEADER_FLAG, false);
  
  // Render the appropriate header based on feature flag
  if (isNewHeaderEnabled) {
    return <NewHeader routeName={routeName} />;
  }
  
  return <LegacyHeader routeName={routeName} />;
};

export default ZooHeader;
